import { render, staticRenderFns } from "./company_user_item_role.vue?vue&type=template&id=33967fe8"
import script from "./company_user_item_role.vue?vue&type=script&lang=js"
export * from "./company_user_item_role.vue?vue&type=script&lang=js"
import style0 from "./company_user_item_role.vue?vue&type=style&index=0&id=33967fe8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports